import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  CardHeader,
  CircularProgress,
  Link,
} from "@mui/material";
import { PageBar } from "../../CommonComponents";
import UploadFiles from "./UploadFiles";
import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import GoogleSheetsIcon from "@mui/icons-material/Google";
import { SSPCommonButton } from "../../CommonComponents";
const base = "https://";

const Index = () => {
  const [loading, setLoading] = useState(false);
  const [url, setUrl] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileSelect = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleGenerateTemplate = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        base +
          "dto63rh5ue.execute-api.ap-south-1.amazonaws.com/ssp_dev/ssp_visi_prod/download_data",
        {
          type: "SAMP",
        },
        {
          headers: {
            authorization: Cookies.get("ssp_sso_token"),
            "content-type": "application/json",
          },
        }
      );
      if (JSON.parse(response?.data?.body)?.status === "success") {
        window.open(JSON.parse(response?.data?.body)?.data_url, "__self");
        setLoading(false);
      } else {
        toast.error(response?.data?.body?.message || "Something went wrong", {
          position: "top-right",
        });
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
      toast.error("Something went wrong", { position: "top-right" });
    }
  };

  const handleCreateOffer = async () => {
    if (selectedFile == null) {
      toast.error("Please upload your file", { position: "top-right" });
      return;
    }
    const timestamp = new Date()
      .toISOString()
      .replace(/[-:.]/g, "")
      .slice(0, 15);
    const filenameWithTimestamp = `${selectedFile.name
      .split(".")
      .slice(0, -1)
      .join(".")}_${timestamp}.${selectedFile.name.split(".").pop()}`;
    try {
      setLoading(true);
      const response = await axios.post(
        base +
          "dto63rh5ue.execute-api.ap-south-1.amazonaws.com/ssp_dev/ssp_visi_prod/gen_post_url",
        { file_name: filenameWithTimestamp },
        {
          headers: {
            authorization: Cookies.get("ssp_sso_token"),
            "content-type": "application/json",
          },
        }
      );
      if (JSON.parse(response?.data?.body)?.status === "success") {
        const fileUploadData = new FormData();
        const fields = JSON.parse(response?.data?.body)?.response?.fields;
        Object.keys(fields).forEach((key) => {
          fileUploadData.append(key, fields[key]);
        });
        fileUploadData.append("file", selectedFile);
        const responseUpload = await axios.post(
          JSON.parse(response?.data?.body)?.response?.url,
          fileUploadData
        );
        if (responseUpload?.status === 204) {
          const result = await axios.post(
            base +
              "dto63rh5ue.execute-api.ap-south-1.amazonaws.com/ssp_dev/ssp_visi_prod/save_asset_details",
            {
              file_name: JSON.parse(response?.data?.body)?.response?.fields
                ?.key,
            },
            {
              headers: {
                authorization: Cookies.get("ssp_sso_token"),
                "content-type": "application/json",
              },
            }
          );
          if (JSON.parse(result?.data?.body)?.status === "success") {
            toast.success(
              JSON.parse(result?.data?.body)?.message ||
                "File Uploaded Successfully",
              { position: "top-right" }
            );
            setSelectedFile(null);
            setTimeout(() => {
              setLoading(false);
              window.location.reload();
            }, 1500);
          } else {
            toast.error(
              JSON.parse(result?.data?.body)?.message ||
                "File upload Failed, Please try again later!",
              { position: "top-right" }
            );
            setLoading(false);
          }
        } else {
          toast.error("File Upload Failed, Please try again later!", {
            position: "top-right",
          });
          setLoading(false);
        }
      } else {
        toast.error(
          JSON.parse(response?.data?.body)?.message ||
            "Something went wrong, Please try again later!",
          { position: "top-right" }
        );
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      toast.error("Something went Wrong!!", { position: "top-right" });
    }
  };

  return (
    <>
      <Box>
        {loading && (
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999,
            }}
          >
            <CircularProgress color="primary" size={60} />
            <Typography
              variant="h6"
              sx={{ color: "#fff", mt: 2, fontWeight: 500 }}
            >
              Loading...
            </Typography>
          </Box>
        )}
        <PageBar text="Visi Asset Upload" />
        <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: 2,
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)", // Increased box shadow
            border: "1px solid #E0E0E0",
            p: 3,
            display: "flex",
            justifyContent: "center", // Center the content horizontally
            alignItems: "center",
            gap: 3,
            width: "90%",
            mx: "auto",
            marginTop: 3,
          }}
        >
          {/* Google Sheets Section */}
          <Box sx={{ flex: 1, marginLeft: "30%" }}>
            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>Step 1 :</strong> Click on below link to download sample
              template:
            </Typography>
            <Link
              href="#"
              underline="always"
              sx={{ display: "block", mb: 2, color: "#1976D2" }}
              onClick={handleGenerateTemplate}
            >
              Download Sample Template
            </Link>

            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>Step 2 :</strong> Please upload your file below:
            </Typography>
            <Box
              sx={{
                display: { lg: "flex", md: "flex" },
                gap: "1rem",
              }}
            >
              <Box
                p={1}
                sx={{
                  border: "1px solid lightgrey",
                  borderRadius: "5px",
                  marginBottom: { sm: "1rem" },
                }}
              >
                <input
                  type="file"
                  multiple={false}
                  onChange={handleFileSelect}
                />
              </Box>
            </Box>
            <Typography variant="body1" sx={{ mb: 1 }}>
              <strong>Step 3 :</strong> Press below button to initiate the
              process :
            </Typography>
            <SSPCommonButton
              btnText={"Save Data"}
              btnFunction={handleCreateOffer}
            />
          </Box>
        </Box>
        <UploadFiles />
      </Box>
    </>
  );
};

export default Index;
